module.exports = __webpack_public_path__ + "static/img/eicad_item5.37517efe.png";